import React from 'react';
import { Modal, Descriptions, Form, Input, Select, Button } from 'antd';

const { Option } = Select;

export const ModalVehiculo = ({ visible, onCancel, onOk, vehiculo, modoEdicion, loading }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (modoEdicion && vehiculo) {
      form.setFieldsValue(vehiculo);
    }
  }, [vehiculo, modoEdicion, form]);

  return (
    <Modal
      open={visible}
      title={modoEdicion ? 'Editar Vehículo' : 'Detalle del Vehículo'}
      onCancel={onCancel}
      onOk={modoEdicion ? () => form.submit() : onCancel}
      footer={modoEdicion ? [
        <Button key="cancel" onClick={onCancel}>Cancelar</Button>,
        <Button key="ok" type="primary" loading={loading} onClick={() => form.submit()}>
          Guardar
        </Button>
      ] : [<Button key="close" onClick={onCancel}>Cerrar</Button>]}
    >
      {modoEdicion ? (
        <Form
          form={form}
          layout="vertical"
          initialValues={vehiculo}
          onFinish={onOk}
        >
          <Form.Item label="Placa" name="placa">
            <Input disabled />
          </Form.Item>
          <Form.Item label="Marca" name="marca" rules={[{ required: true, message: 'Marca requerida' }]}> <Input /> </Form.Item>
          <Form.Item label="Modelo" name="modelo" rules={[{ required: true, message: 'Modelo requerido' }]}> <Input /> </Form.Item>
          <Form.Item label="Color" name="color" rules={[{ required: true, message: 'Color requerido' }]}> <Input /> </Form.Item>
          <Form.Item label="Tipo de gasolina" name="tipo_gasolina" rules={[{ required: true, message: 'Tipo requerido' }]}> <Select><Option value="Magna">Magna</Option><Option value="Premium">Premium</Option><Option value="Diesel">Diesel</Option><Option value="Eléctrico">Eléctrico</Option><Option value="Otro">Otro</Option></Select> </Form.Item>
          <Form.Item label="Engomado" name="engomado" rules={[{ required: true, message: 'Engomado requerido' }]}> <Input /> </Form.Item>
        </Form>
      ) : (
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="Placa">{vehiculo?.placa}</Descriptions.Item>
          <Descriptions.Item label="Marca">{vehiculo?.marca}</Descriptions.Item>
          <Descriptions.Item label="Modelo">{vehiculo?.modelo}</Descriptions.Item>
          <Descriptions.Item label="Color">{vehiculo?.color}</Descriptions.Item>
          <Descriptions.Item label="Tipo de gasolina">{vehiculo?.tipo_gasolina}</Descriptions.Item>
          <Descriptions.Item label="Engomado">{vehiculo?.engomado}</Descriptions.Item>
          <Descriptions.Item label="Sucursal">{vehiculo?.sucursal}</Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};
